var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIdealBlock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 376,
    height: 416,
    viewBox: "0 0 376 416",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M188.493 48.1323L145.361 73.0385V224.343L188.493 249.249L231.624 224.343V73.0385L188.493 48.1323Z",
    fill: "#ECFFFA",
    stroke: "#0F1936",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M231.624 224.343L188.492 249.249V97.9447L231.624 73.0386V224.343Z",
    fill: "#ECFFFA",
    stroke: "#0F1936",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M188.493 48.1323V97.9446L145.361 224.343V73.0385L188.493 48.1323Z",
    fill: "#ECFFFA",
    stroke: "#0F1936",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M188.493 249.249L145.361 224.343V73.0386L188.493 97.9447V249.249Z",
    fill: "#0F1936",
    stroke: "#0F1936",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M188.493 48.1323L231.624 73.0385L188.493 97.9446L145.361 73.0385L188.493 48.1323Z",
    fill: "#00C495",
    stroke: "#0F1936",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M180.373 253.309V122.303L137.242 97.3965L94.0898 122.303V253.309L137.242 278.215L180.373 253.309Z",
    fill: "#ECFFFA",
    stroke: "#0F1936",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M180.374 253.309L137.242 278.215V147.209L180.374 122.303V253.309Z",
    fill: "#ECFFFA",
    stroke: "#0F1936",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M137.242 147.209L94.0898 253.309V122.303L137.242 97.3965V147.209Z",
    fill: "#ECFFFA",
    stroke: "#0F1936",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M137.242 278.215L94.0898 253.309V122.303L137.242 147.209V278.215Z",
    fill: "#0F1936",
    stroke: "#0F1936",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M180.373 122.303L137.242 147.209L94.0898 122.303L137.242 97.3965L180.373 122.303Z",
    fill: "#00C495",
    stroke: "#0F1936",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M129.123 282.274V212.164L85.9714 187.258L42.8398 212.164V282.274L85.9714 307.181L129.123 282.274Z",
    fill: "#ECFFFA",
    stroke: "#0F1936",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M129.123 282.275L85.9707 307.181V237.07L129.123 212.164V282.275Z",
    fill: "#ECFFFA",
    stroke: "#0F1936",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M85.9714 237.07L42.8398 282.274V212.164L85.9714 187.258V237.07Z",
    fill: "#ECFFFA",
    stroke: "#0F1936",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M85.9714 307.181L42.8398 282.275V212.164L85.9714 237.07V307.181Z",
    fill: "#0F1936",
    stroke: "#0F1936",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M129.123 212.164L85.9714 237.07L42.8398 212.164L85.9714 187.258L129.123 212.164Z",
    fill: "#00C495",
    stroke: "#0F1936",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M282.874 253.309V142.601L239.743 117.695L196.611 142.601V253.309L239.743 278.215L282.874 253.309Z",
    fill: "#ECFFFA",
    stroke: "#0F1936",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M282.874 253.309L239.742 278.215V167.507L282.874 142.601V253.309Z",
    fill: "#ECFFFA",
    stroke: "#0F1936",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M239.743 167.507L196.611 253.309V142.601L239.743 117.695V167.507Z",
    fill: "#ECFFFA",
    stroke: "#0F1936",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M239.743 278.215L196.611 253.309V142.601L239.743 167.507V278.215Z",
    fill: "#0F1936",
    stroke: "#0F1936",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M282.874 142.601L239.743 167.507L196.611 142.601L239.743 117.695L282.874 142.601Z",
    fill: "#00C495",
    stroke: "#0F1936",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M231.624 282.274V212.164L188.493 187.258L145.361 212.164V282.274L188.493 307.181L231.624 282.274Z",
    fill: "#ECFFFA",
    stroke: "#0F1936",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M231.624 282.275L188.492 307.181V237.07L231.624 212.164V282.275Z",
    fill: "#ECFFFA",
    stroke: "#0F1936",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M188.493 237.07L145.361 282.274V212.164L188.493 187.258V237.07Z",
    fill: "#ECFFFA",
    stroke: "#0F1936",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M188.493 307.181L145.361 282.275V212.164L188.493 237.07V307.181Z",
    fill: "#0F1936",
    stroke: "#0F1936",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M231.624 212.164L188.493 237.07L145.361 212.164L188.493 187.258L231.624 212.164Z",
    fill: "#00C495",
    stroke: "#0F1936",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M180.373 311.24V220.831L137.242 195.925L94.0898 220.831V311.24L137.242 336.146L180.373 311.24Z",
    fill: "#ECFFFA",
    stroke: "#0F1936",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M180.374 311.24L137.242 336.147V245.737L180.374 220.831V311.24Z",
    fill: "#ECFFFA",
    stroke: "#0F1936",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M137.242 245.737L94.0898 311.24V220.831L137.242 195.925V245.737Z",
    fill: "#ECFFFA",
    stroke: "#0F1936",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M137.242 336.147L94.0898 311.24V220.831L137.242 245.737V336.147Z",
    fill: "#0F1936",
    stroke: "#0F1936",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M180.373 220.831L137.242 245.737L94.0898 220.831L137.242 195.925L180.373 220.831Z",
    fill: "#00C495",
    stroke: "#0F1936",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M334.124 282.274V212.164L290.993 187.258L247.861 212.164V282.274L290.993 307.181L334.124 282.274Z",
    fill: "#ECFFFA",
    stroke: "#0F1936",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M334.124 282.275L290.992 307.181V237.07L334.124 212.164V282.275Z",
    fill: "#ECFFFA",
    stroke: "#0F1936",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M290.993 237.07L247.861 282.274V212.164L290.993 187.258V237.07Z",
    fill: "#ECFFFA",
    stroke: "#0F1936",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M290.993 307.181L247.861 282.275V212.164L290.993 237.07V307.181Z",
    fill: "#0F1936",
    stroke: "#0F1936",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M334.124 212.164L290.993 237.07L247.861 212.164L290.993 187.258L334.124 212.164Z",
    fill: "#00C495",
    stroke: "#0F1936",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M282.874 311.24V261.428L239.743 236.522L196.611 261.428V311.24L239.743 336.147L282.874 311.24Z",
    fill: "#ECFFFA",
    stroke: "#0F1936",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M282.874 311.241L239.742 336.147V286.334L282.874 261.428V311.241Z",
    fill: "#ECFFFA",
    stroke: "#0F1936",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M239.743 286.334L196.611 311.24V261.428L239.743 236.522V286.334Z",
    fill: "#ECFFFA",
    stroke: "#0F1936",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M239.743 336.147L196.611 311.241V261.428L239.743 286.334V336.147Z",
    fill: "#0F1936",
    stroke: "#0F1936",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M282.874 261.428L239.743 286.334L196.611 261.428L239.743 236.522L282.874 261.428Z",
    fill: "#00C495",
    stroke: "#0F1936",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M231.624 340.206V310.692L188.493 285.786L145.361 310.692V340.206L188.493 365.112L231.624 340.206Z",
    fill: "#ECFFFA",
    stroke: "#0F1936",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M231.624 340.206L188.492 365.112V335.599L231.624 310.692V340.206Z",
    fill: "#ECFFFA",
    stroke: "#0F1936",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M188.493 335.598L145.361 340.206V310.692L188.493 285.786V335.598Z",
    fill: "#ECFFFA",
    stroke: "#0F1936",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M188.493 365.112L145.361 340.206V310.692L188.493 335.599V365.112Z",
    fill: "#0F1936",
    stroke: "#0F1936",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M231.624 310.692L188.493 335.598L145.361 310.692L188.493 285.786L231.624 310.692Z",
    fill: "#00C495",
    stroke: "#0F1936",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M354.988 304.739V113.235L188.483 17.4927L23.998 113.235V304.739L188.483 400.48L354.988 304.739Z",
    stroke: "#0F1936",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "10 10"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M23.998 113.235L188.483 210.394",
    stroke: "#0F1936",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "10 10"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M354.987 113.235L188.482 210.394",
    stroke: "#0F1936",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "10 10"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M188.482 400.48V210.394",
    stroke: "#0F1936",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "10 10"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdealBlock);
export default __webpack_public_path__ + "static/media/idealBlock.b32e4fd331550f75069cf018c1cd59db.svg";
export { ForwardRef as ReactComponent };